<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';

	interface Props {
		title: string;
		links: { href: string; label: string }[];
		testid?: string;
	}

	const { title, links, testid = 'seo-footer-link-block' }: Props = $props();

	let show = $state(false);
</script>

<h2 class="border-b-1 border-b-solid text-coloredneutral-soft text-bold text-md m-0" data-testid={`${testid}-title`}>
	<Button
		variant="ghost"
		iconPosition="right"
		onclick={() => (show = !show)}
		icon="chevron-right"
		text={title}
		iconClasses={show ? 'rotate-90' : undefined}
		class="w-full justify-between"
	/>
</h2>
<ul class:show data-testid={`${testid}-list`}>
	{#each links as { label, href }, index (`${label}-${index}`)}
		<li>
			<Link {href} {label} class="flex justify-start" />
		</li>
	{/each}
</ul>

<style>
	ul {
		height: 0;
		overflow: hidden;
		margin: 0;
		padding: 0;
		list-style: none;
	}
	ul.show {
		height: auto;
		padding: 0.5rem;
	}
</style>
